import * as React from 'react';
import { Chip, ChipProps, styled } from '@material-ui/core';
import TextStyles from '../theme/text';
import { neutral, status } from '../theme/colors';

interface StatusChipProps {
  color: 'info' | 'success' | 'warning' | 'error';
  size: 'medium' | 'small';
}

const StatusChip = styled(
  ({ color, size, ...other }: StatusChipProps & Omit<ChipProps, keyof StatusChipProps>) => (
    <Chip {...other} />
  )
)({
  ...TextStyles.label1,
  backgroundColor: ({ color }: StatusChipProps) => status[color].dark,
  color: neutral[100],
  fontWeight: 600,
  fontSize: 14,
  height: ({ size }: StatusChipProps) => (size == 'small' ? '20px' : '24px'),
  borderRadius: ({ size }: StatusChipProps) => (size == 'small' ? '10px' : '12px'),
  '& .MuiChip-label': {
    padding: '0 8px'
  }
});

export default StatusChip;
